export enum Role {
  Tenant = "TENANT",
  Landlord = "LANDLORD",
}
